export const initialState = {
    name: '',
};

export const enginesPath = '/engines';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Engines', path: enginesPath },
    { label: 'Add Engine', path: '' },
];

export const breadCrumbTrailView = [
    { label: 'Admin', path: '' },
    { label: 'Engines', path: enginesPath },
    { label: 'View Engine', path: '' },
];

export const addHeader = 'Engine Details';
export const viewHeader = 'View Engine Details';
